// knowledgeDetails.pipeline.common.* — the shared stage/state/impact vocabulary.
export default {
  stages: {
    sources: 'Sources',
    parse: 'Parse',
    chunk: 'Chunk',
    contextualise: 'Contextualise',
    embed: 'Embed',
    index: 'Index',
    graphrag: 'GraphRAG',
    retrieve: 'Retrieve',
  },
  stageHints: {
    sources: 'Where documents come from: uploads and connectors.',
    parse: 'Docling reads each file into text, tables and figures.',
    chunk: 'The parsed text is split into chunks that can be retrieved.',
    contextualise:
      'An LLM adds document context to every chunk before it is embedded.',
    embed: 'The embedding model turns each chunk into a vector.',
    index: 'Chunks and vectors are written to the search index.',
    graphrag: 'An LLM extracts entities and relations into a knowledge graph.',
    retrieve: 'A question is matched against the index to find chunks.',
  },
  states: {
    pending: 'Pending',
    parsing: 'Parsing',
    done: 'Done',
    failed: 'Failed',
    cancelled: 'Cancelled',
  },
  stateHints: {
    pending: 'Waiting for someone to press Parse.',
    parsing: 'Being processed now.',
    done: 'Processed and searchable.',
    failed: 'Stopped on an error. The error line says why.',
    cancelled: 'Stopped before it finished.',
  },
  dots: {
    label: 'Pipeline progress',
    done: 'done',
    active: 'in progress',
    failed: 'failed',
    cancelled: 'cancelled',
    pending: 'not started',
    na: 'not used',
    item: '{{stage}}: {{status}}',
  },
  impact: {
    needsReparse: 'Needs re-parse',
    immediate: 'Applies immediately',
    llmBilled: 'LLM-billed',
    locked: 'Locked',
    nextImport: 'Next import',
    nextAutoSync: 'Next auto-sync',
  },
  impactHints: {
    needsReparse:
      'Only documents parsed after the change use it. Re-parse to apply it to existing documents.',
    immediate: 'Takes effect on the next search, with no re-parse.',
    llmBilled:
      'Runs an LLM call per chunk or document, billed to your account.',
    locked: 'Cannot change while the knowledge base has chunks.',
    nextImport: 'Used by the next connector import or sync.',
    nextAutoSync: 'Used by the next scheduled auto-sync.',
  },
  nav: {
    label: 'Knowledge base sections',
    back: 'Back to knowledge bases',
    overview: 'Overview',
    sources: 'Connector',
    history: 'Run History',
    documents: 'Documents',
    configuration: 'Configuration',
    graph: 'Graph',
    retrieval: 'Retrieval',
  },
  strip: {
    label: 'Ingestion pipeline',
    expand: 'Show {{stage}} details',
    collapse: 'Hide {{stage}} details',
  },
  howItWorks: {
    show: 'See how it works under the hood',
    hide: 'Hide the details',
    step: 'Step {{n}}:',
  },
  ranked: {
    threshold: 'Threshold {{value}}',
    rank: 'Rank {{rank}}',
  },
};
